export const COMPONENT_ATTRIBUTE = 'data-react-shortcode';
export const PROP_PREFIX = 'data-prop-';
